module.exports = require("./../../_gen/starling/events/EnterFrameEvent");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/EnterFrameEvent.js
// module id = 179
// module chunks = 0